<template>
  <div id="job-search" class="fill-height" style="background-color: #f5f5f5;">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="5">
          <v-card class="elevation-2 rounded-xl">
            <v-card-title class="py-6 justify-center teal darken-4 rounded-t-xl">
              <h2 class="text-h5 font-weight-bold mb-0 white--text text-center">TRA CỨU KẾT QUẢ TUYỂN DỤNG</h2>
            </v-card-title>
            <v-card-text class="pa-6">
              <p class="text-center text-body-1 grey--text text--darken-2 mb-6">
                Vui lòng nhập số điện thoại hoặc CCCD/CMND để tra cứu trạng thái hồ sơ của bạn.
              </p>
              <v-form ref="form" v-model="valid" lazy-validation @submit.prevent>
                <v-text-field
                  v-model="searchQuery"
                  :rules="[v => !!v || 'Vui lòng nhập thông tin tra cứu']"
                  label="Số điện thoại / CCCD"
                  outlined
                  dense
                  clearable
                  prepend-inner-icon="mdi-magnify"
                  class="rounded-lg mb-4"
                  hide-details="auto"
                  @keyup.enter="search"
                ></v-text-field>
              </v-form>
              
              <v-expand-transition>
                <div v-if="hasSearched && !isLoading" class="mt-6">
                   <!-- Placeholder cho kết quả tra cứu -->
                   <v-alert
                     v-if="!searchResult || searchResult.length === 0"
                     type="info"
                     text
                     color="blue-grey"
                     class="rounded-lg mb-0"
                   >
                     Không tìm thấy kết quả phù hợp. Vui lòng kiểm tra lại thông tin.
                   </v-alert>
                   
                   <template v-else>
                      <v-card v-for="(item, index) in searchResult" :key="index" outlined class="rounded-lg border mb-3 cursor-pointer hover-card" @click="fetchProfile(item.code)">
                        <v-card-text>
                         <div class="d-flex justify-space-between mb-2">
                           <span class="font-weight-medium">Mã ứng tuyển:</span>
                           <span class="font-weight-bold text-uppercase">{{ item.code }}</span>
                         </div>
                         <div class="d-flex justify-space-between mb-2">
                           <span class="font-weight-medium">Họ tên:</span>
                           <span class="font-weight-bold text-uppercase">{{ item.name }}</span>
                         </div>
                         <div class="d-flex justify-space-between mb-2">
                           <span class="font-weight-medium">Vị trí ứng tuyển:</span>
                           <span class="teal--text font-weight-bold">{{ item.job }}</span>
                         </div>
                         <div class="d-flex justify-space-between">
                           <span class="font-weight-medium">Trạng thái:</span>
                           <v-chip small :color="getStatusColor(item.status)" text-color="white" class="font-weight-bold px-3">
                             {{ item.status == 'NEW' ? 'Mới': (item.status == 'ACCEPT' ? 'Duyệt' : 'Không duyệt') }}
                           </v-chip>
                         </div>
                       </v-card-text>
                     </v-card>
                   </template>
                </div>
              </v-expand-transition>
            </v-card-text>
            <v-card-actions class="px-6 pb-6 pt-0">
              <v-btn
                color="teal darken-4"
                block
                dark
                large
                class="rounded-lg font-weight-bold"
                :loading="isLoading"
                @click="search"
                type="button"
              >
                TRA CỨU
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- Dialog Thông tin ứng viên -->
      <v-dialog v-model="dialog" max-width="800px" scrollable :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card :class="$vuetify.breakpoint.xsOnly ? '' : 'rounded-xl'">
          <v-card-title class="teal darken-4 py-4 d-flex justify-space-between align-center" style="position: sticky; top: 0; z-index: 10;">
            <span class="text-h6 font-weight-bold mb-0 white--text">THÔNG TIN ỨNG VIÊN</span>
            <v-btn icon dark @click="dialog = false" class="ma-0">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-text class="pa-4 pa-sm-6" :style="$vuetify.breakpoint.xsOnly ? '' : 'max-height: 75vh;'">
            <div v-if="isProfileLoading" class="text-center py-10">
              <v-progress-circular indeterminate color="teal darken-4" size="50"></v-progress-circular>
            </div>
            
            <v-form v-else-if="profileData" ref="profileForm" @submit.prevent="saveProfile">
              <v-row>
                <v-col cols="12" sm="4" class="text-center">
                  <v-avatar size="120" color="grey lighten-2" class="mb-3 elevation-2">
                    <img v-if="profileData.avatar" :src="profileData.avatar" alt="Avatar">
                    <v-icon v-else size="60" color="grey darken-1">mdi-account</v-icon>
                  </v-avatar>
                  <v-text-field
                    v-model="profileData.name"
                    label="Họ tên"
                    outlined dense
                    class="font-weight-bold mt-2"
                    hide-details="auto"
                  ></v-text-field>
                  <div class="text-subtitle-2 grey--text text--darken-1 mt-2">
                    Mã: {{ profileData.code }}
                  </div>
                </v-col>
                
                <v-col cols="12" sm="8">
                  <v-row dense>
                    <v-col cols="12">
                      <v-radio-group v-model="profileData.gender" row dense hide-details class="mt-0 mb-3">
                        <template v-slot:label><div class="mr-4 grey--text text--darken-1">Giới tính</div></template>
                        <v-radio label="Nam" :value="true" color="teal darken-4"></v-radio>
                        <v-radio label="Nữ" :value="false" color="teal darken-4"></v-radio>
                      </v-radio-group>
                    </v-col>
                    
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="profileData.doB" type="date" label="Ngày sinh" outlined dense hide-details="auto" class="mb-2"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="profileData.phoneNumber" label="Số điện thoại" outlined dense hide-details="auto" class="mb-2"></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="profileData.idNumber" label="CCCD/CMND" outlined dense hide-details="auto" class="mb-2"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="profileData.idDate" type="date" label="Ngày cấp" outlined dense hide-details="auto" class="mb-2"></v-text-field>
                    </v-col>
                    
                    <v-col cols="12">
                      <v-autocomplete v-model="profileData.idPlace" :items="idPlaces" label="Nơi cấp" outlined dense hide-details="auto" class="mb-2"></v-autocomplete>
                    </v-col>
                    
                    <v-col cols="12" sm="6">
                      <v-autocomplete v-model="profileData.cityId1" :items="newCities" item-text="name" item-value="id" label="Tỉnh/Thành" outlined dense hide-details="auto" class="mb-2" @change="fetchNewWard(profileData.cityId1)"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-autocomplete v-model="profileData.wardId1" :items="newWards" item-text="name" item-value="id" label="Phường/Xã" outlined dense hide-details="auto" class="mb-2"></v-autocomplete>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field v-model="profileData.address1" label="Địa chỉ chi tiết" outlined dense hide-details="auto"></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-4 justify-end" v-if="!isProfileLoading && profileData">
            <v-btn text color="grey darken-1" class="font-weight-bold mr-2" @click="dialog = false">HỦY</v-btn>
            <v-btn color="teal darken-4" dark class="font-weight-bold px-6 rounded-lg" :loading="isSavingProfile" @click="saveProfile">LƯU THAY ĐỔI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import http from "@/components/services/http-common";

export default {
  name: 'JobSearch',
  data() {
    return {
      valid: true,
      searchQuery: '',
      isLoading: false,
      hasSearched: false,
      searchResult: null,
      dialog: false,
      isProfileLoading: false,
      isSavingProfile: false,
      profileData: null,
      newCities: [],
      newWards: [],
    };
  },
  computed: {
    idPlaces() {
      const fixed = ["Cục Cảnh sát ĐKQL cư trú và DLQG về dân cư", "Cục Cảnh sát quản lý hành chính về trật tự xã hội"];
      if (!this.newCities) return fixed;
      const cityData = this.newCities.map(x => x.name);
      return fixed.concat(cityData);
    }
  },
  mounted() {
    this.fetchNewCity();
  },
  methods: {
    search() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        this.hasSearched = true;
        
        http.get('candidates/job-search', { params: { inputSearch: this.searchQuery } })
          .then(res => {
            let data = res.data.data || res.data;
            if (Array.isArray(data) && data.length > 0) {
              let mappedData = data.map(item => ({
                code: item.code,
                name: item.name || item.Name || item.hoTen,
                job: item.job || item.Job || item.JobName || item.jobName || item.viTriUngTuyen,
                status: item.status || item.Status || item.trangThai,
                rawDate: item.createdAt || item.CreatedAt || item.createdDate || item.CreatedDate || item.ngayNop || item.ngayTao || null,
                id: item.id || item.Id || 0
              }));

              mappedData.sort((a, b) => {
                const acceptStatuses = ['Trúng tuyển', 'Accept', 'Đã tiếp nhận', 'Đạt'];
                const aIsAccept = acceptStatuses.includes(a.status);
                const bIsAccept = acceptStatuses.includes(b.status);
                
                if (aIsAccept && !bIsAccept) return -1;
                if (!aIsAccept && bIsAccept) return 1;
                
                if (a.rawDate && b.rawDate) {
                  return new Date(b.rawDate) - new Date(a.rawDate);
                }
                if (a.id && b.id) {
                  return b.id - a.id;
                }
                return 0;
              });

              this.searchResult = mappedData;
            } else {
              this.searchResult = [];
            }
          })
          .catch(err => {
            console.error(err);
            this.searchResult = null;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    fetchNewCity() {
      http.get("addresses/cities")
        .then(res => {
          this.newCities = res.data.data;
        })
        .catch(err => console.error(err));
    },
    fetchNewWard(val) {
      if (!val) {
        this.newWards = [];
        return;
      }
      http.get('addresses/wards?cityId=' + val)
        .then(res => {
          this.newWards = res.data.data;
        })
        .catch(err => console.error(err));
    },
    getStatusColor(status) {
      switch(status) {
        case 'Đang xử lý': return 'orange darken-2';
        case 'Trúng tuyển': return 'green darken-2';
        case 'Từ chối': return 'red darken-2';
        default: return 'grey darken-2';
      }
    },
    fetchProfile(code) {
      if (!code) return;
      this.dialog = true;
      this.isProfileLoading = true;
      this.profileData = null;
      
      http.get(`candidates/profile/${code}`)
        .then(res => {
          let data = res.data.data || res.data;
          this.profileData = {
            code: data.code || data.Code,
            avatar: data.avatar || data.Avatar,
            name: data.name || data.Name,
            gender: data.gender !== undefined ? data.gender : data.Gender,
            doB: data.doB || data.DoB,
            phoneNumber: data.phoneNumber || data.PhoneNumber,
            idNumber: data.idNumber || data.IdNumber,
            idDate: data.idDate || data.IdDate,
            idPlace: data.idPlace || data.IdPlace,
            cityId1: data.cityId1 || data.CityId1,
            wardId1: data.wardId1 || data.WardId1,
            address1: data.address1 || data.Address1,
          };
          
          if (this.profileData.cityId1) {
            this.fetchNewWard(this.profileData.cityId1);
          }

          if (this.profileData.doB) {
            this.profileData.doB = this.formatDateForInput(this.profileData.doB);
          }
          if (this.profileData.idDate) {
            this.profileData.idDate = this.formatDateForInput(this.profileData.idDate);
          }
        })
        .catch(err => {
          console.error('Error fetching profile:', err);
        })
        .finally(() => {
          this.isProfileLoading = false;
        });
    },
    saveProfile() {
      if (!this.profileData) return;
      this.isSavingProfile = true;
      
      let payload = {
        Code: this.profileData.code,
        Avatar: this.profileData.avatar,
        Name: this.profileData.name,
        Gender: this.profileData.gender,
        DoB: this.profileData.doB,
        PhoneNumber: this.profileData.phoneNumber,
        IdNumber: this.profileData.idNumber,
        IdDate: this.profileData.idDate,
        IdPlace: this.profileData.idPlace,
        CityId1: Number(this.profileData.cityId1) || 0,
        WardId1: Number(this.profileData.wardId1) || 0,
        Address1: this.profileData.address1
      };

      http.put(`candidates/profile/${this.profileData.code}`, payload)
        .then(res => {
          // Success
          this.dialog = false;
          // Optionally trigger a re-fetch of the search here if needed
          // this.search();
        })
        .catch(err => {
          console.error('Error saving profile:', err);
        })
        .finally(() => {
          this.isSavingProfile = false;
        });
    },
    formatDateForInput(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #e0e0e0;
}
.cursor-pointer {
  cursor: pointer;
}
.hover-card:hover {
  background-color: #f0fdfa !important;
  border-color: #004d40 !important;
  transition: all 0.3s ease;
}
</style>
